import { ElMessage } from "element-plus";
import { createStore } from "vuex";

export default createStore({
  state: {
    navIndex: 0,
    navData: [{ path: "HomeMain", title: "首页" }],
    components: [],
  },
  mutations: {
    setLoginUser(state, data) {
      state.loginUser = data;
      // state.loginUser.is_super_auth = 1;
    },

    //存储所有组件
    setCompontents(state, data) {
      if (!state.components.includes(data)) state.components.push(data);
    },

    onNavInit(state) {
      const nav = localStorage.getItem("navData");
      if (nav) {
        const data = JSON.parse(nav);
        if (data.path == "HomeMain") {
          state.navData = [{ path: "HomeMain", title: "首页" }];
          state.navIndex = 0;
        } else {
          state.navData = [{ path: "HomeMain", title: "首页" }, data];
          state.navIndex = 1;
        }
      }
    },

    //打开菜单
    openMenu(state, data) {
      let index = state.navData.findIndex(
        (w) =>
          w.path == data.path &&
          JSON.stringify(w.data) == JSON.stringify(data.data)
      );
      if (index < 0) {
        if (state.navData?.length > 20) {
          ElMessage.warning("最多只能打开20个页签！");
          return false;
        }
        state.navData.push(data);
        state.navIndex = state.navData.length - 1;
      } else {
        state.navIndex = index;
        if (data.refresh) {
          state.navData[index].key = Math.random();
        }
      }
      localStorage.setItem("navData", JSON.stringify(data));
    },

    //关闭指定菜单
    onCloseMy(state, index) {
      state.navData.splice(index, 1);

      if (index <= state.navIndex) {
        state.navIndex = state.navIndex - 1;

        localStorage.setItem(
          "navData",
          JSON.stringify(state.navData[state.navIndex])
        );
      }
    },

    //关闭当前菜单
    onCloseCurrent(state) {
      state.navData.splice(state.navIndex, 1);
      state.navIndex = state.navIndex - 1;
    },

    //选项卡切换菜单事件
    onMenuChange(state, index) {
      state.navIndex = index;
      const data = state.navData[index];
      localStorage.setItem("navData", JSON.stringify(data));
    },

    /**
     * 关闭其他菜单
     * @param {*} state
     * @param {*} data {type:  1-关闭左侧标签 2-关闭右侧标签  3-关闭其他标签; index: 当前标签下标}
     */
    onCloseOther(state, data) {
      switch (data.type) {
        case 1: //关闭左侧标签
          if (data.index > 1) {
            state.navData.splice(1, data.index - 1);
            state.navIndex = 1;

            localStorage.setItem(
              "navData",
              JSON.stringify(state.navData[state.navIndex])
            );
          }
          break;
        case 2:
          if (data.index > 0) {
            state.navData.splice(
              data.index + 1,
              state.navData.length - data.index
            );
            state.navIndex = data.index;
          }
          break;
        case 3:
          if (data.index > 0) {
            state.navData = [
              { path: "HomeMain", title: "首页" },
              state.navData[data.index],
            ];
            state.navIndex = 1;
          }
          break;
        default:
          break;
      }

      if (data.index > 0)
        localStorage.setItem(
          "navData",
          JSON.stringify(state.navData[state.navIndex])
        );

      // if (index == 0) {
      //   state.navData = [{ path: "HomeMain", title: "首页" }];
      //   state.navIndex = 0;
      // } else {
      //   state.navData = [
      //     { path: "HomeMain", title: "首页" },
      //     state.navData[index],
      //   ];
      //   state.navIndex = 1;
      // }
    },

    //刷新当前标签
    onRefresh(state, index) {
      state.navData[index].key = Math.random();
    },

    //刷新当前标签
    onRefreshCurrent(state) {
      state.navData[state.navIndex].key = Math.random();
    },

    //设置浏览器的宽度
    onSetBrowserWidth(state) {
      state.width = window.innerWidth;
    },
  },
  actions: {},
  modules: {},
});
